import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownStatusList, EmptyString, FormTypeAdd, PageSize, PageTypeCount, PageTypeGetPaged, PaginationBack, PaginationFirst, PaginationLast, PaginationNext } from "utils/Constant";
import { ApiGetLocationList, ApiDeleteLocation, ApiCheckIsAdmin } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import EditIcon from "assets/icon/EditIcon";
import PaginationButton from "components/Input/PaginationButton";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import AddButton from "components/Button/AddButton";
import { GetStatus } from "utils/helpers";

export default function Location(){
    let navigate = useNavigate()
    
    const { data: locationList, fetch: getLocationList } = useFetch(ApiGetLocationList)
    const { fetch: getLocationCount } = useFetch(ApiGetLocationList)
    const { fetch: deleteLocation } = useFetch(ApiDeleteLocation)
    const { fetch: checkIsAdmin } = useFetch(ApiCheckIsAdmin)

    const [kostName, setKostName] = useState(EmptyString)
    const [address, setAddress] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [statusOptions, setStatusOptions] = useState(DropdownStatusList)

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    const addBtnClick = () => {
        navigate("/location/form?locationId=&formType=" + FormTypeAdd)
    }

    useEffect(() => {
        setLoading(true)

        fCheckIsAdmin().then(() => {
            fBindGrid(0).then(() => {
                setLoading(false)
            })
        })
    },[])

    // Function Api Call
    async function fGetLocationList(index){
        await getLocationList({
            data: {
                locationName: kostName,
                address: address, 
                status: status,
                pageSize: PageSize,
                pageIndex: parseInt(index),
                pageType: PageTypeGetPaged,
                sortBy: "A.LocationName",
                sortOrder: "ASC"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        }).finally(() => {
        })
    }
    async function fGetLocationCount(){
        let dataCount = 0

        await getLocationCount({
            data: {
                locationName: kostName,
                address: address, 
                status: status,
                pageSize: PageSize,
                pageIndex: 0,
                pageType: PageTypeCount,
                sortBy: "A.LocationName",
                sortOrder: "ASC"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                dataCount = response.data.dataCount
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })

        return dataCount
    }
    async function fDeleteLocation(paramLocationId){
        await deleteLocation({
            data: {
                locationId: paramLocationId,
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: {
                        onSuccess: async () => {
                            setSuccessModal({ isOpen: false })
                            navigate("/location")
                        }
                    }
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fCheckIsAdmin(){
        await checkIsAdmin({
            data: {
                id: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                if (response.data.isAdmin === false){
                    setFailModal({
                        isOpen: true,
                        data: {
                            onSuccess: async () => {
                                setFailModal({isOpen: false})
                                localStorage.setItem("IsAdmin", "0")
                                window.location.href = "/"
                            }
                        },
                        message: "User don't have admin access right!"
                    })
                }
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function Grid
    async function fBindGrid(index){
        setLoading(true)

        let totalData = await fGetLocationCount()

        let i = index !== null ? (index !== "" ? parseInt(index) : 0) : 0

        fSetPaginationOptions(totalData, index)
        fGetLocationList(i).then(() => {
            setLoading(false)
        })
    }
    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = parseInt(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i <= numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fBindGrid(0)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fBindGrid(index)
        }
    }
    function fPaginationIndexChange(index){
        setPageIndex(index)
        fBindGrid(index)
    }

    // Function Button
    function fEditBtnClick(locationId){
        navigate("/location/form?locationId=" + locationId + "&formType=Edit")
    }
    function fDeleteBtnClick(locationId){
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading(true)

                    fDeleteLocation(locationId).then(() => {
                        setLoading(false)
                        fBindGrid(pageIndex)
                    })
                }
            }
        })
    }
    function fSearchBtnClick(){
        fBindGrid(0)
    }

    function fEnterKeyDown(e){
		if(e.key === 'Enter'){
			fBindGrid(0)
		}
	}

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Location</span>
            </div>
            <hr />

            <div className="flex flex-col sm:flex-row justify-between gap-4 mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
                    <div className="flex flex-col gap-2 w-full sm:w-3/12 md:w-72 2xl:w-72">
                        <span>Location Name</span>
                        <input className="input" value={kostName} onChange={(e) => { setKostName(e.target.value) }} onKeyDown={(e) => { fEnterKeyDown(e) }} />
                    </div>
                    <div className="flex flex-col gap-2 w-full sm:w-3/12 md:w-72 2xl:w-72">
                        <span>Address</span>
                        <input className="input" value={address} onChange={(e) => { setAddress(e.target.value) }} onKeyDown={(e) => { fEnterKeyDown(e) }} />
                    </div>
                    <div className="flex flex-col gap-2 w-full sm:w-3/12 md:w-72 2xl:w-72">
                        <span>Status</span>
                        <Dropdown value={ status } options={ statusOptions } onChange={(e) => { setStatus(e.value) }} placeholder={"All"} />
                    </div>
                </div>
                <div>
                    <div className="flex items-end justify-end h-full">
                        <SearchButton onClick={() => { fSearchBtnClick() }} />
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <AddButton onClick={addBtnClick} />
            </div>
           
            <div className="mt-5">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Location Name</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Address</th>
                            <th className="font-semibold text-left px-2 hidden md:table-cell">City</th>
                            <th className="font-semibold text-left px-2 hidden md:table-cell">Province</th>
                            <th className="font-semibold text-left px-2 hidden md:table-cell">Phone</th>
                            <th className="font-semibold text-left px-2 hidden md:table-cell">Status</th>
                            <th className="font-semibold w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        {locationList?.data?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2">
                                        <span>{ data.locationName }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ data.address }</span>
                                    </td>
                                    <td className="px-2 hidden md:table-cell">
                                        <span>{ data.city }</span>
                                    </td>
                                    <td className="px-2 hidden md:table-cell">
                                        <span>{ data.province }</span>
                                    </td>
                                    <td className="px-2 hidden xl:table-cell">
                                        <span>{ data.phone }</span>
                                    </td>
                                    <td className="px-2 hidden md:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex justify-center py-2 gap-2 px-2">
                                        <button className="button flex gap-2" onClick={() => fEditBtnClick( data.locationId )}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className="button flex gap-2" onClick={() => fDeleteBtnClick( data.locationId )}>
                                            <TrashIcon className="w-4 fill-white" />
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <PaginationButton btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                options={paginationOptions} value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
            />

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading ? (<LoadingModal />) : (<div />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}